import { useDispatch, useSelector } from "react-redux";
import Blog from "./Blog";

function Blogs() {
    const blogs = useSelector((state) => state.blog);
    const filters = useSelector((state) => state.filters);

    const filterByAuthor = (blog) => {
        const { author } = filters;
        if(author){
            return author===blog.author
        }
        return true;
    };

    const filterByCategory = (blog) => {
        const { category } = filters;
        if(category){
            return category===blog.category
        }
        return true;
    };
    const filterBySearch= (blog) => {
        const { search } = filters;
        if(search){
            let titleArr = blog.title.toLowerCase().split(' ');
            return titleArr.includes(search.toLowerCase());
        }
        return true;
    };

    return (
        <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
            {blogs.filter(filterByAuthor).filter(filterByCategory).filter(filterBySearch).map((blog)=>(
                <Blog key={blog.id} blog={blog} />
            ))
            }
            
        </div>
    );
}

export default Blogs;
